/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SavePublicConfigResult
 */
export interface SavePublicConfigResult {
  /**
   *
   * @type {string}
   * @memberof SavePublicConfigResult
   */
  guid: string
}

/**
 * Check if a given object implements the SavePublicConfigResult interface.
 */
export function instanceOfSavePublicConfigResult(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'guid' in value

  return isInstance
}

export function SavePublicConfigResultFromJSON(
  json: any,
): SavePublicConfigResult {
  return SavePublicConfigResultFromJSONTyped(json, false)
}

export function SavePublicConfigResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavePublicConfigResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    guid: json['Guid'],
  }
}

export function SavePublicConfigResultToJSON(
  value?: SavePublicConfigResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    Guid: value.guid,
  }
}
